var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCardsId40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2272_8964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8657 10.1118H4.13431C2.85201 10.1118 1.8125 11.1513 1.8125 12.4336V29.4602C1.8125 30.7425 2.85201 31.782 4.13431 31.782H35.8657C37.148 31.782 38.1875 30.7425 38.1875 29.4602V12.4336C38.1875 11.1513 37.148 10.1118 35.8657 10.1118Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13431 10.1118H35.8657C37.148 10.1118 38.1875 11.1513 38.1875 12.4336V14.2251H1.8125V12.4336C1.8125 11.1513 2.85201 10.1118 4.13431 10.1118Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.448 22.4948C31.5166 22.4948 32.3829 21.6285 32.3829 20.56C32.3829 19.4914 31.5166 18.6251 30.448 18.6251C29.3794 18.6251 28.5132 19.4914 28.5132 20.56C28.5132 21.6285 29.3794 22.4948 30.448 22.4948Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7393 25.5906C27.7393 23.8809 28.952 22.4949 30.448 22.4949C31.9441 22.4949 33.1568 23.8809 33.1568 25.5906H27.7393Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2272_8964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCardsId40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCardsID40.8aab7fa89414d0176738197857cd8e4c.svg";
export { ForwardRef as ReactComponent };